import {createAction} from 'redux-actions'
import  * as ActionTypes from './actionTypes'

export const setAuthorizationInfo = (authorizationInfo) => dispatch => {
    dispatch(setFieldsEditability({
        baseAccountInformationEditable: authorizationInfo['accountInformationEditable'],
        accessToActiTimeEditable: authorizationInfo['accessToActiTimeEditable'],
        accessToActiPlansEditable: authorizationInfo['accessToActiPlansEditable'],
        departmentEditable: authorizationInfo['departmentEditable'],
        timeZoneEditable: authorizationInfo['timeZoneEditable'],
        hireAndReleaseDatesEditable: authorizationInfo['hireAndReleaseDatesEditable'],
        approvalSettingsEditable: authorizationInfo['approvalSettingsEditable'],
        workScheduleEditable: authorizationInfo['workScheduleEditable'],
        overtimeSettingsEditable: authorizationInfo['overtimeSettingsEditable'],
        costOfWorkRatesEditable: authorizationInfo['costOfWorkRatesEditable'],

        permissionsEditable: authorizationInfo['permissionsEditable'],
        teamScopeEditable: authorizationInfo['teamScopeEditable'],
        manageScopeEditable: authorizationInfo['manageScopeEditable'],
        hasRightsToDeleteUser: authorizationInfo['hasRightsToDeleteUser'],
    }))
}

export const setFieldsEditability = createAction(ActionTypes.FIELDS_EDITABILITY_SET)

export const setCanEditEntireUser = createAction(ActionTypes.CAN_EDIT_ENTIRE_USER_SET)


// WEBPACK FOOTER //
// ./web/js/panels/user/authorizationInfo/actions.js